import RouteItem from ".";
import PageUnderConstruction from "../pages/error-page/PageUnderConstruction";
import Achievements from "../pages/student/Achievements";
import AntiRagging from "../pages/student/AntiRagging";
import CodeOfConduct from "../pages/student/CodeOfConduct";
import Council from "../pages/student/Council";
import Scholarship from "../pages/student/scholership";
import GrievanceRedressal from "../pages/student/GrievanceRedressal";
import MentorshipProgramme from "../pages/student/MentorshipProgramme";
import ParentTeacher from "../pages/student/ParentTeacher";
import Placement from "../pages/student/Placement";

// Student's Corner SubMenu Pages
export const studentsCornerRoutes: RouteItem = {
  key: "router-students-corner",
  title: "Student’s Corner",
  tooltip: "Student’s Corner",
  path: "/students-corner",
  enabled: true,
  appendDivider: true,
  showInHeader: true,
  subRoutes: [
    {
      key: "router-students-council",
      title: "Student Council",
      tooltip: "Student Council",
      path: "student-council",
      enabled: true,
      component: Council,
      appendDivider: true,
    },
    {
      key: "router-students-awards-achievements",
      title: "Students Awards & Achievements",
      tooltip: "Students Awards & Achievements",
      path: "students-awards-achievements",
      enabled: true,
      component: Achievements,
      appendDivider: true,
    },
    {
      key: "router-anti-ragging-committee",
      title: "Anti-Ragging Committee",
      tooltip: "Anti-Ragging Committee",
      path: "anti-ragging-committee",
      enabled: true,
      component: AntiRagging,
      appendDivider: true,
    },
    {
      key: "router-grievance-redressal",
      title: "Grievance Redressal Committee",
      tooltip: "Grievance Redressal Committee",
      path: "grievance-redressal-committee",
      enabled: true,
      component: GrievanceRedressal,
      appendDivider: true,
    },
    {
      key: "router-mentorship-programme",
      title: "Mentorship Programme",
      tooltip: "Mentorship Programme",
      path: "mentorship-programme",
      enabled: true,
      component: MentorshipProgramme,
      appendDivider: true,
    },
    {
      key: "router-parent-teacher-corner",
      title: "Parent-Teacher Corner",
      tooltip: "Parent-Teacher Corner",
      path: "parent-teacher-corner",
      enabled: true,
      component: ParentTeacher,
      appendDivider: true,
    },
    {
      key: "router-code-of-conduct",
      title: "Code of Conduct",
      tooltip: "Code of Conduct",
      path: "code-of-conduct",
      enabled: true,
      component: CodeOfConduct,
      appendDivider: true,
    },
    {
      key: "router-scholarship",
      title: "Scholarship",
      tooltip: "Scholarship",
      path: "scholarship",
      enabled: true,
      component: Scholarship,
      appendDivider: true,
    },
    {
      key: "router-placements",
      title: "Placements",
      tooltip: "Placements",
      path: "placements",
      enabled: true,
      component: Placement,
      appendDivider: true,
    },
  ],
};
